import { render } from "./DomainControlTable.vue?vue&type=template&id=c7d42bd8&scoped=true"
import script from "./DomainControlTable.vue?vue&type=script&lang=js"
export * from "./DomainControlTable.vue?vue&type=script&lang=js"

import "./DomainControlTable.vue?vue&type=style&index=0&id=c7d42bd8&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7d42bd8"]])

export default __exports__